<!--
  Переключатель языка: дропдаун со списком языков из i18nManager (заполняет
  проект через setSupportedLocales/setDefaultLocale). Пункты — именно <a href>,
  не @click: краулер видит языковые версии, а полная перезагрузка отдаёт
  SSR-страницу сразу на нужном языке. href = текущий URL со сменённым
  префиксом: default-язык живёт без префикса. При одном языке не рендерится.
-->
<template>
  <Dropdown
    v-if="Object.keys(locales).length > 1"
    align="right"
    class="locale-switcher"
  >
    <template #label>
      <span
        class="flex flex-nowrap flex-v-center gap-thin pd-thin radius-small t-nowrap ease-linear cursor-pointer hover:bg-card"
        aria-label="language"
      >
        {{ locales[locale] || locale }}
        <IconChevronBottom class="i-small" />
      </span>
    </template>

    <nav class="flex flex-column pd-thin gap-thin" aria-label="language">
      <a
        v-for="(label, code) in locales"
        :key="code"
        :href="hrefFor(code)"
        class="d-block pd-thin radius-small t-nowrap ease-linear"
        :class="code === locale ? 'bg-card' : 'hover:bg-card'"
      >
        {{ label }}
      </a>
    </nav>
  </Dropdown>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { i18nManager } from '@martyrs/src/modules/core/views/classes/i18n.manager.js';

import Dropdown from '@martyrs/src/design-system/components/Dropdown/Dropdown.vue';
import IconChevronBottom from '@martyrs/src/modules/icons/navigation/IconChevronBottom.vue';

const { locale } = useI18n();
const route = useRoute();

// Подписи из setSupportedLocales({ ru: '🇷🇺 RU', ... }); проект, передавший
// массив кодов, получает коды капсом.
const locales = i18nManager.localeNames
  || Object.fromEntries((i18nManager.supportedLocales || []).map(code => [code, code.toUpperCase()]));

function hrefFor(code) {
  // Текущий URL без языкового префикса; query и hash сохраняются.
  let suffix = route.fullPath;
  if (route.params.locale) {
    suffix = suffix.replace(new RegExp(`^/${route.params.locale}(?=[/?#]|$)`), '');
  }
  if (code === i18nManager.defaultLocale) {
    return suffix.startsWith('/') ? suffix : `/${suffix}`;
  }
  if (suffix === '/') suffix = '';
  return `/${code}${suffix}`;
}
</script>
